import React from 'react';
import styled, { css } from 'styled-components';
import ProjectList from '../component/project/ProjectList';
import ProjectListFixed from '../component/project/fixed/ProjectListFixed';
import ScrollDownArrow from '../shared/component/ScrollDownArrow';
import ArchivePageFrame from '../shared/component/ArchivePageFrame';
import { useShortCut } from '../shared/hooks/useShortCut';
import { useNavLayout } from '../shared/hooks/useNavLayout';
import { NavLayout } from '../shared/enum/EnumRepository';

const Projects: React.FC = () => {
  const { handleCmdE } = useShortCut();
  const navLayout = useNavLayout();

  return (
    <ProjectsFrame
      $isFold={navLayout === NavLayout.FOLD}
      onKeyDown={(e) => handleCmdE(e)}
      tabIndex={-1}
    >
      <ScrollDownArrow />
      {navLayout === NavLayout.FIXED ? <ProjectListFixed /> : <ProjectList />}
    </ProjectsFrame>
  );
}

export default Projects;

const ProjectsFrame = styled(ArchivePageFrame)<{ $isFold: boolean }>`
  ${({ $isFold }) => $isFold && css`
    && {
      display: block;
      padding: 0;
    }
  `}
`;
